import React, { useState } from "react";
import Breadcrumb from "../components/Breadcrumb";

const ContactPage = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        comment: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Data:", formData);
        alert("Form submitted!");
    };

    const breadcrumbItems = [
        { label: "Trang chủ", href: "/" },
        { label: "Liên hệ", href: `/contact` },
    ];
    return (
        <>
            <Breadcrumb items={breadcrumbItems} />
            <div className="w-full flex justify-center items-center mt-8">
                <div className="w-[--page-width] flex flex-col gap-4">
                    {/* Google Map */}
                    <div className="w-full h-96 rounded-lg overflow-hidden">
                        <iframe
                            title="Google Map"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3672.122093667208!2d72.80107187467246!3d22.999893779185467!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04d6bb5f10d6d%3A0xa2a0bb8a0d3d7ca5!2sTrinity%20Business%20Park!5e0!3m2!1sen!2sin!4v1635947180400!5m2!1sen!2sin"
                            className="w-full h-full border-0"
                            allowFullScreen=""
                            loading="lazy"
                        ></iframe>
                    </div>

                    {/* Contact section */}
                    <div className="grid md:grid-cols-2 gap-10">
                        {/* Info */}
                        <div>
                            <h2 className="text-2xl font-semibold mb-4">Liên lạc với chúng tôi</h2>
                            <p className="mb-2">
                                164 Khuất Duy Tiến, Thanh Xuân, Hà Nội
                            </p>
                            <p className="mb-2">Thứ hai – Thứ sáu 10 AM – 8 PM</p>
                            <p className="mb-2">(+84) 971 772 818</p>
                            <p className="mb-2">cobonla.fun@gmail.com</p>
                        </div>

                        {/* Form */}
                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Your Name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="w-full p-3 border rounded"
                                    required
                                />
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Your Email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="w-full p-3 border rounded"
                                    required
                                />
                            </div>

                            <input
                                type="text"
                                name="phone"
                                placeholder="Phone number"
                                value={formData.phone}
                                onChange={handleChange}
                                className="w-full p-3 border rounded"
                            />

                            <textarea
                                name="comment"
                                placeholder="Comment"
                                value={formData.comment}
                                onChange={handleChange}
                                className="w-full p-3 border rounded h-32"
                            ></textarea>

                            <button
                                type="submit"
                                className="px-6 py-2 bg-[--color-button-3] text-white rounded-full hover:bg-green-800"
                            >
                                Send
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </>

    );
};

export default ContactPage;
